import { render, staticRenderFns } from "./CrosswordClueList.vue?vue&type=template&id=64ffeb9c&"
import script from "./CrosswordClueList.vue?vue&type=script&lang=js&"
export * from "./CrosswordClueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CrosswordClueEntry: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/CrosswordClueEntry.vue').default})
